/**
 * Risk Rating enum — pure leaf module with no dependencies.
 * Extracted from riskScoreUtil.jsx to break the circular dependency:
 * sorters.ts → riskScoreUtil.jsx → tableUtils.jsx → ColumnFilter.jsx → sorters.ts
 *
 * ENG-130868
 */
export enum RiskRating {
  Good = 'goodRiskScore',
  Fair = 'fairRiskScore',
  Poor = 'poorRiskScore',
  VeryPoor = 'veryPoorRiskScore',
}
